export const SET_COLLECTIONS = 'SET_COLLECTIONS';
export const SET_COLLECTION = 'SET_COLLECTION';
export const COLLECTIONS_LOAD_START = 'COLLECTIONS_LOAD_START';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const RESET_COLLECTION = 'RESET_COLLECTION';
export const COLLECTION_LOAD_ERROR = 'COLLECTION_LOAD_ERROR';
export const SET_COLLECTION_FILTER = 'SET_COLLECTION_FILTER';
export const RESET_COLLECTION_FILTERS = 'RESET_COLLECTION_FILTERS';
export const FILTER_EXCLUDED_TREND = 'FILTER_EXCLUDED_TREND';
